import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import HomeWarrantyCenterWrapper from "@components/layouts/homewarrantycenterWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function HomeWarranty(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <HomeWarrantyCenterWrapper>
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </HomeWarrantyCenterWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
